import { useCallback, useEffect, useRef, useState } from "react";
import Badge from "../../components/badges/Badges";
import Button from "../../components/button/Button";
import { Spiner } from "../../components/spinner/Spiner";
import TableList, { GridCol, GridRow } from "../../components/table/TableList";
import { auth } from "../../firebase";
import companiesQuery from "../../firestore/Companies.query";
import { Groups, newGroup } from "../../model/Groups";
import { GroupAddModal } from "./GroupAddModal";
import { GroupAdminListModal } from "./GroupAdminListModal"
import { GroupAdminSettingModal } from "./GroupAdminSettingModal"
import { APP_USE, AttendingGroups, GetAppUseStateFromUserData, UserData } from "../../model/Users";
import userQuery from "../../firestore/User.query";
import { Company } from "../../model/Companies";
import { useDispatch } from "react-redux";
import { AlertValue, alertOpen } from "../../features/alert.slice";
import { ConstMessage } from "../../config/const";
import { GroupUserEditModal } from "./GroupUserEditModal";
import { NotEditableModal } from "./NotEditableModal";
import { SearchKeys } from "../../model/SearchKeys";
import { requestGetGroupAdmin, requestGetGroups } from "../../api/Groups.api";
import { requestGetUser } from "../../api/Users.api";

export const GroupList = () => {

  // ログイン中の団体管理者情報
  const currentUser = auth.currentUser;

  const isDisabled = useRef(false);

  const dispatch = useDispatch();

  const [isLode, setIsLode] = useState(true);
  const [groups, setGroups] = useState<Groups[]>([]);
  const [isOpen, setIsOpen] = useState(false);
  const [isAdminListOpen, setIsAdminListOpen] = useState(false);
  const [isAdminSettingOpen, setIsAdminSettingOpen] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [group, setGroup] = useState<Groups | undefined>();
  const [userList, setUserList] = useState<UserData[]>([]);
  const [company, setCompany] = useState<Company>();
  const [attendingGroups, setAttendingGroups] = useState<AttendingGroups[]>([]);
  const [groupUserList, setGroupUserList] = useState<UserData[]>([]);
  const [isDeleteGroup, setIsDeleteGroup] = useState<'deleteTrue' | 'deleteFalse'>('deleteFalse');
  const [checkedAdminFlgList, setCheckedAdminFlgList] = useState<string[]>();
  const [changeCheckedAdminFlgList, setChangeCheckedAdminFlgList] = useState<string[]>();
  const [changeUncheckedAdminFlgList, setChangeUncheckedAdminFlgList] = useState<string[]>();
  const [adminFlgList, setAdminFlgList] = useState<UserData[]>([]);
  const [selectableUserList, setSelectableUserList] = useState<UserData[]>([]);
  const [adminRows, setAdminRows] = useState<GridRow[]>([]);
  const [adminsettingRows, setAdminsettingRows] = useState<GridRow[]>([]);
  const [isGroupUserEditOpen, setIsGroupUserEditOpen] = useState(false);
  const [checkedGroupUserList, setCheckedGroupUserList] = useState<string[]>();
  const [changeCheckedGroupUserList, setChangeCheckedGroupUserList] = useState<string[]>();
  const [changeUncheckedGroupUserList, setChangeUncheckedGroupUserList] = useState<string[]>();
  const [groupUserEditRows, setGroupUserEditRows] = useState<GridRow[]>([]);
  const [groupUserEditList, setGroupUserEditList] = useState<UserData[]>([]);
  const [searchUserList, setSearchUserList] = useState<UserData[]>([]);
  const [searchUserListFlg, setSearchUserListFlg] = useState(false);
  const [searchKey1List, setSearchKey1List] = useState<{ value: string; disabled: boolean; }[]>([]);
  const [searchKey2List, setSearchKey2List] = useState<{ value: string; disabled: boolean; }[]>([]);
  const [searchKey3List, setSearchKey3List] = useState<{ value: string; disabled: boolean; }[]>([]);
  const [filteredActiveUsers, setFilteredActiveUsers] = useState<string[]>([])
  const [isNotEditableModalOpen, setIsNotEditableModalOpen] = useState(false);
  const [searchKeyList, setSearchKeyList] = useState<SearchKeys[]>();
  const [firstPageFlg, setFirstPageFlg] = useState(false);
  const [isUpdateSearchKeys, setIsUpdateSearchKeys] = useState(false);
  const [isUpdateAdmin, setIsUpdateAdmin] = useState(false);
  const [nowPage, setNowPage] = useState(1);
  const [selectNumber, setSelectNumber] = useState(50);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [activeCount, setActiveCount] = useState<number>(0);
  const [sortKey, setSortKey] = useState<string>("name_kana");
  const [sortOrder, setSortOrder] = useState<string>("asc");
  const [searchCondition, setSearchCondition] = useState<any>({}); 
  const [firstUserPageFlg, setFirstUserPageFlg] = useState(true);
  const [nowUserPage, setNowUserPage] = useState(1);
  const [selectUserNumber, setSelectUserNumber] = useState(10);
  const [totalUserCount, setTotalUserCount] = useState<number>(0);
  const [upGroupData, setUpGroupData] = useState<Groups>();
  const [totalGroupCount, setTotalGroupCount] = useState(0);
  const [firstGroupPageFlg, setFirstGroupPageFlg] = useState(true);
  const [nowGroupPage, setNowGroupPage] = useState(1);
  const [selectGroupNumber, setSelectGroupNumber] = useState(10);
  const [isGroupUserListLoading, setIsGroupUserListLoading] = useState(false);
  const [firstAdminUserPageFlg, setFirstAdminUserPageFlg] = useState(true);
  const [nowAdminUserPage, setNowAdminUserPage] = useState(1);
  const [selectAdminUserNumber, setSelectAdminUserNumber] = useState(10);
  const [totalAdminUserCount, setTotalAdminUserCount] = useState<number>(0);
  const [isUserListLoading, setIsUserListLoading] = useState(false);
  const [isGroupAdminPageFlg, setIsGroupAdminPageFlg] = useState(false);;
  const [isAdminListLoading, setIsAdminListLoading] = useState(false);
  const [isAdminSettingLoading, setIsAdminSettingLoading] = useState(false);
  const [updateKey, setUpdateKey] = useState(0); 
  const [rowListAdmin, setRowListAdmin] = useState<CustomGridRow[]>([]);
  const [isUpdateLoading, setIsUpdateLoading] = useState(false);

  // 検索キー1,2,3取得
  useEffect(() => {
    if (!currentUser?.tenantId) return;
    const fetchSearchKeys = async () => {
      const companyData = await companiesQuery.getCompany(currentUser?.tenantId!);
      setCompany(companyData);
      const searchKeys = await companiesQuery.getSearchKeys(companyData.id);
      setSearchKeyList(searchKeys);

      const emptyValue = [{ value: '', disabled: false }];
      ['userSearchKey1', 'userSearchKey2', 'userSearchKey3'].forEach((keyName, idx) => {
        const item = searchKeys.find(s => s.name === keyName);
        const list = item?.keyValues?.sort((a, b) => a.sort - b.sort).map(obj => ({ value: obj.searchName, disabled: false })) ?? emptyValue;
        if (idx === 0) setSearchKey1List(list);
        if (idx === 1) setSearchKey2List(list);
        if (idx === 2) setSearchKey3List(list);
      });
    };
    fetchSearchKeys();
  }, [currentUser?.tenantId]);

  // グループ一覧取得
  useEffect(() => {
    if (!currentUser?.tenantId) return;
    const fetchGroups = async () => {
      try {
        const apiSortKey = sortKey === "name" ? "name_kana" : sortKey;
        const result = await requestGetGroups(currentUser?.tenantId!, nowPage, selectNumber, apiSortKey, sortOrder);
        if (!result.success) {
          console.error("グループ取得失敗:", result.error);
          return;
        }

        console.debug("requestGetGroups result:", result);

        let pageData = result.groups;
        let calculatedActiveCount = (result as any).activeCount ?? pageData.filter(g => !g.deleteFlg).length;
        
        if (upGroupData) {
          const exists = pageData.some(g => g.id === upGroupData.id);
          if (exists) {
            // 元のグループの状態を取得
            const originalGroup = pageData.find(g => g.id === upGroupData.id);
            const wasActive = originalGroup && !originalGroup.deleteFlg;
            const isNowActive = !upGroupData.deleteFlg;
            
            // ページデータを更新
            pageData = pageData.map(g => g.id === upGroupData.id ? upGroupData : g);
            
            // 状態変化があれば、全体のactiveCountを調整
            if (wasActive && !isNowActive) {
              // 有効→無効: -1
              calculatedActiveCount = ((result as any).activeCount ?? calculatedActiveCount) - 1;
            } else if (!wasActive && isNowActive) {
              // 無効→有効: +1
              calculatedActiveCount = ((result as any).activeCount ?? calculatedActiveCount) + 1;
            }
          }
        }

        setGroups(pageData);
        setTotalCount((result as any).totalCount ?? pageData.length);
        setActiveCount(calculatedActiveCount);
      } finally {
        setIsLode(false);
      }
    };
    fetchGroups();
  }, [currentUser?.tenantId, nowPage, selectNumber, sortKey, sortOrder, updateKey]);

  // ページング処理
  const pagingFunc = useCallback((page: number) => {
    setFirstPageFlg(false);
    setNowPage(page);
  }, []);

  // グループ編集 所属利用者一覧取得
  useEffect(() => {
    if (!isOpen || !group?.id) {
      setIsGroupUserListLoading(false);
      return
    }
    const fetchGroupByPage = async () => {
      try {
        const result = await requestGetUser(nowGroupPage, selectGroupNumber, { groups: [group.id] });
        if (result.success) {
          setGroupUserList(result.users);
          setTotalGroupCount(result.totalCount);
        } else {
          console.error("所属ユーザー取得失敗:", result.error);
        }
      } finally {
        setIsGroupUserListLoading(false);
      }
    };
    fetchGroupByPage();
  }, [nowGroupPage, selectGroupNumber, isOpen, group?.id]);

  // グループ編集 所属利用者一覧取得
  const pagingGroupFunc = useCallback((page: number) => {
    setFirstGroupPageFlg(false);
    setNowGroupPage(page);
  }, []);

  // ユーザー編集 利用者一覧取得
  useEffect(() => {
    if (!isGroupUserEditOpen) return;
    const fetchUsersByPage = async () => {
      const mergedSearchConditions = {
        ...searchCondition,
        accountSuspensionFlg: false,
      };
      const result = await requestGetUser(nowUserPage, selectUserNumber, mergedSearchConditions);
      if (result.success) {
        setGroupUserEditList(result.users);
        setTotalUserCount(result.totalCount);
      } else {
        console.error("ユーザー取得失敗:", result.error);
      }
      setIsUserListLoading(false);
    };
    fetchUsersByPage();
  }, [nowUserPage, selectUserNumber, searchCondition, isGroupUserEditOpen]);

  // ユーザー編集　検索ボタン押下
  const handleSearch = (condition: any) => {
    setIsUserListLoading(true);
    setFirstUserPageFlg(true);
    setSearchCondition(condition);
    setNowUserPage(1);
  };

  // ユーザー編集 ページング処理
  const pagingUserFunc = useCallback((page: number) => {
    setFirstUserPageFlg(false);
    setNowUserPage(page);
  }, []);

  // 設定 管理者一覧取得
  useEffect(() => {
    if (!isAdminListOpen) return;
    const fetchGroupAdminPage = async () => {
      try {
        const result = await requestGetGroupAdmin(currentUser?.tenantId!, group?.id!);
        if (result.success) {
          setAdminFlgList(result.users);
          setCheckedAdminFlgList(result.users.map(u => u.id));
          const adminRows: GridRow[] = result.users.map(item => {
            const age = item.birthDate instanceof Date ? new Date().getFullYear() - item.birthDate.getFullYear() : undefined;
            const ageString = age !== undefined && !isNaN(age) ? `(${age}歳)` : '';
            const name = `${item.lastName !== undefined && item.lastName !== '' ? item.lastName : '未登録'} ${ageString}`
            return {
              rowData: {
                id: item.id.substring(item.id.indexOf(company?.displayId ?? "") + (company?.displayId?.length ?? 0)),
                name: (<div className="whitespace-nowrap">{name}</div>)
              },
              style: "sm:whitespace-normal",
            };
          });
          setAdminRows(adminRows);
        }
      } finally {
        setIsAdminListLoading(false);
        setIsUpdateAdmin(!isUpdateAdmin);
      }
    };
    fetchGroupAdminPage();
  }, [isAdminListOpen, isUpdateAdmin]);

  // 管理者一覧 管理者設定取得
  useEffect(() => {
    if (!isAdminSettingOpen) return;
    const fetchAdminUserPage = async () => {
      try {
        const result = await requestGetUser(nowAdminUserPage, selectAdminUserNumber, { groups: [group?.id], admin: true });
        if (result.success) {
          setSelectableUserList(result.users);
          setTotalAdminUserCount(result.totalCount);
        } else {
          console.error("管理者設定取得失敗:", result.error);
        }
      } finally {
        setIsAdminSettingLoading(false);
      }
    };
    fetchAdminUserPage();
  }, [nowAdminUserPage, selectAdminUserNumber, isAdminSettingOpen]);

  // 管理者設定 ページング処理
  const pagingAdnminUserFunc = useCallback((page: number) => {
    setFirstAdminUserPageFlg(false);
    setNowAdminUserPage(page);
  }, []);

  // 管理者設定 管理者一覧取得
  useEffect(() => {
    if (!isAdminSettingOpen) return;
    const adminsettingRows = selectableUserList?.map(item => {
      const isDefaultChecked = item.groups.some(g => g.id === group?.id && g.adminFlg);
      const isAdded = changeCheckedAdminFlgList?.includes(item.id) ?? false;
      const isRemoved = changeUncheckedAdminFlgList?.includes(item.id) ?? false;
      const checked = (isDefaultChecked || isAdded) && !isRemoved;
      const age = item.birthDate instanceof Date ? new Date().getFullYear() - item.birthDate.getFullYear() : undefined;
      const ageString = age !== undefined && !isNaN(age) ? `(${age}歳)` : '';
      const name = `${item.lastName || '未登録'} ${ageString}`;
      return {
        rowData: {
          adminFlg: (<input type="checkbox" data-id={item.id} onChange={adminFlgOnChange} checked={checked} />),
          id: item.id.substring(item.id.indexOf(company?.displayId ?? "") + (company?.displayId?.length ?? 0)),
          name: (<div className="whitespace-nowrap">{name}</div>)
        },
        style: "sm:whitespace-normal",
      };
    }) ?? [];
    setAdminsettingRows(adminsettingRows);
  }, [isAdminSettingOpen, selectableUserList, changeCheckedAdminFlgList, changeUncheckedAdminFlgList, isUpdateAdmin]);

  useEffect(() => {
    // グループユーザ編集画面用の利用者一覧データ生成
    if (!isGroupUserEditOpen) return;
    try {
      const f = async () => {
        const groupUserRows: GridRow[] = (groupUserEditList ?? []).map<GridRow>((item) => {
          const appUse = GetAppUseStateFromUserData(item);

          // 表示用チェック判定
          const isDefaultChecked = item.groups.some((g) => g.id === group?.id);
          const isAdded = !!(changeCheckedGroupUserList?.includes(item.id));
          const isRemoved = !!(changeUncheckedGroupUserList?.includes(item.id));
          const checked = (isDefaultChecked || isAdded) && !isRemoved;

          return {
            rowData: {
              groupUserAddFlg: (
                <div className="px-2">
                  <input
                    id={item.id}
                    name={item.id}
                    type="checkbox"
                    className="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                    data-id={item.id}
                    disabled={group?.deleteFlg === true}
                    onChange={groupUserOnChange}
                    checked={checked}
                  />
                </div>
              ),
              id: item.id.substring(item.id.indexOf(company?.displayId ?? "") + (company?.displayId?.length ?? 0)),
              name: (<div className={"whitespace-nowrap"}>{item.lastName !== undefined && item.lastName !== '' ? item.lastName : ''}</div>),
              groups: (<>{item.groups
                .sort((a, b) => (a.id < b.id) ? 1 : -1)
                  .map(
                  (group, index) => (
                    <Badge
                      key={`${group}${index}${item.id}`}
                      color={group.color}>
                      {group.name}
                    </Badge>
                  )
              )}</>),
              deleteFlg: (<>{appUse === APP_USE.SUSPEND
                ? (<Badge color="gray">停止</Badge>) : (appUse === undefined)
                ? (<></>) : appUse === APP_USE.UNUSEABLE
                ? (<Badge color="red">不可</Badge>) : (<Badge color="green">利用可</Badge>)}</>),
              admin: (<>{(item.admin === undefined)
                ? (<></>) : item.admin
                ? (<Badge color="red">運営者</Badge>) : (<Badge className={"whitespace-nowrap"} color="indigo">利用者</Badge>)}</>),
            },
            style: 'sm:whitespace-normal'
          }
        }) ?? [];
        setGroupUserEditRows(groupUserRows);
      };
      f();
    } finally {
      setIsUserListLoading(false);
    }
  }, [isGroupUserEditOpen, groupUserEditList, changeCheckedGroupUserList, changeUncheckedGroupUserList, group?.id, company?.displayId]);

  useEffect(() => {
    setFirstUserPageFlg(true)
  }, [searchUserListFlg, searchUserList])

  const columns: GridCol[] = [
    {
      field: "no",
      headerName: "No.",
      style: "w-1/12",
    },
    {
      field: "name",
      headerName: "名称",
      style: "",
    },
    {
      field: "explanation",
      headerName: "説明",
      style: "w-1/4",
    },
    {
      field: "userCount",
      headerName: "利用者数",
      style: "w-1/12",
    },
    {
      field: "deleteFlg",
      headerName: "有効/無効",
      style: "w-1/12",
    },
    {
      field: "adminCount",
      headerName: "管理者数",
      style: "w-1/12",
    },
    {
      field: "adminEdit",
      headerName: "管理者",
      style:"w-1/12",
      sort: false
    },
    {
      field: "edit",
      headerName: "詳細",
      style:"w-1/12",
      sort: false
    },
    {
      field: "userEdit",
      headerName: "",
      style:"w-1/12",
      sort: false
    },
  ];

  const rowList: GridRow[] = (groups ?? []).map<GridRow>((group, index) => {
    return {
      rowData: {
        no: (nowPage - 1) * selectNumber + index + 1,
        name: (<div className={"sm:whitespace-normal"}>{group.name}</div>),
        explanation: (<div className={"sm:whitespace-normal"}>{group.explanation}</div>),
        userCount: (<div className={"text-end px-4"}>{group.userCount}</div>),
        deleteFlg:(<>{group.deleteFlg
          ? (<Badge color="red">無効</Badge>)
          : (<Badge color="green">有効</Badge>)}</>),
        adminCount: (<div className={"text-end px-4"}>{group.adminCount}</div>),
        adminEdit: (
          <Button
            onClick={() => onSelectAdminUser(group, true)}
            children="設定" />),
        edit:(
          <Button
            onClick={() => onCreateGroup(group, true)}
            children="詳細" />),
        userEdit:(
          <Button
            onClick={() => onGroupUserEdit(group)}
            children="ユーザ編集" />)
      },
      sortableRowData: {
        name: group.nameKana,
        explanation: group.explanation,
        userCount: group.userCount,
        deleteFlg: group.deleteFlg,
        adminCount: group.adminCount,
      }
    }
  });

  const userCols: GridCol[] = [
    {
      field: "id",
      headerName: "利用者番号",
      style: "",
    },
    {
      field: "name",
      headerName: "名前",
      style: "",
    },
    {
      field: "groups",
      headerName: "所属グループ",
      style: "",
    },
    {
      field: "deleteFlg",
      headerName: "アプリ利用",
      style: "",
    },
    {
      field: "admin",
      headerName: "役割",
      style: "",
    },
  ];

  const adminCols: GridCol[] = [
    {
      field: "id",
      headerName: "利用者番号",
      style: "w-1/12",
      sort: false
    },
    {
      field: "name",
      headerName: "名前",
      style: "w-1/3",
      sort: false
    },
  ];

  const adminsettingCols: GridCol[] = [
    {
      field: "adminFlg",
      headerName: "",
      style: "w-1/5",
      sort: false
    },
    {
      field: "id",
      headerName: "利用者番号",
      style: "w-1/3",
      sort: false
    },
    {
      field: "name",
      headerName: "名前",
      style: "",
      sort: false
    },
  ];

  const userRows: GridRow[] = groupUserList?.map<GridRow>((item) => {
    let age: number | undefined = undefined;
    const birthDate = Number.isNaN(item?.birthDate?.getTime()) ? undefined : item?.birthDate;
    if(birthDate !== undefined){
      const today = new Date();
      const thisYearsBirthday = new Date(today.getFullYear(), birthDate.getMonth(), birthDate.getDate());
      age = today.getFullYear() - birthDate.getFullYear();
      if(today < thisYearsBirthday){
        age--;
      }
    }
    const ageString = age !== undefined ? `(${age}歳)` : '';
    const name = `${item.lastName !== undefined && item.lastName !== '' ? item.lastName : '未登録'} ${ageString}`
    const appUse = GetAppUseStateFromUserData(item);
    return {
      rowData: {
        id: (
          <div className={"whitespace-nowrap"}>
            {item.id.substring(item.id.indexOf(company?.displayId ?? "") + (company?.displayId?.length ?? 0))}
          </div>
        ),
        name: (<div className={"whitespace-nowrap"}>{name}</div>),
        groups: (
          <>
            {
              item.groups.map(
                (group, index) => (
                  <Badge
                    key={`${group}${index}${item.id}`}
                    color={group.color}
                    className={group.disabled ? "opacity-30" : ""}>
                    {group.name}
                  </Badge>
                )
              )
            }
          </>
        ),
        deleteFlg: (
          <div className={"whitespace-nowrap"}>
            {appUse === APP_USE.UNUSEABLE
              ? (<Badge color="red">不可</Badge>)
              : (<Badge color="green">利用可</Badge>)}
          </div>
        ),
        admin: (
          <div className={"whitespace-nowrap"}>
            {item.admin
          ? (<Badge color="red">運営者</Badge>)
          : (<Badge color="indigo">利用者</Badge>)}
          </div>
        ),
      },
      sortableRowData: {
        id: item.id.substring(item.id.indexOf(company?.displayId ?? "") + (company?.displayId?.length ?? 0)),
        name: item.lastNameKana ?? '',
        groups: item.groups.filter((group) => !group.disabled).sort((a, b) => a.id < b.id ? 1 : -1).join('/'),
        deleteFlg: item.deleteFlg ?? false,
        admin: item.admin ?? false
      },
      style: "sm:whitespace-normal",
    }
  }) ?? [];

  const groupUserEditCols: GridCol[] = [
    {
      field: "groupUserAddFlg",
      headerName: "",
      style: "",
      sort: false
    },
    {
      field: "id",
      headerName: "利用者番号",
      style: "",
      sort: false
    },
    {
      field: "name",
      headerName: "名前",
      style: "",
      sort: false,
    },
    {
      field: "groups",
      headerName: "所属グループ",
      style: "",
      sort: false
    },
    {
      field: "deleteFlg",
      headerName: "アプリ利用",
      style: "",
      sort: false
    },
    {
      field: "admin",
      headerName: "役割",
      style: "",
      sort: false
    }
  ];

  //グループ作成／編集 登録押下
  const onClickSubmit = async (data: Groups) => {
    if(!isDisabled.current){
      try {
        // ログイン中の団体管理者情報
        const currentUser = auth.currentUser;
        // 団体のdisplayIdを取得
        const companyData = await companiesQuery.getCompany(currentUser?.tenantId!);
        // 団体グループ取得
        let companyGroups = await companiesQuery.getGroups(companyData.id);
        // 編集対象のグループ以外のグループを取得
        companyGroups = companyGroups.filter(group => group.id !== data.id)
        // グループ名称が一致するグループを取得し重複チェックを行う
        companyGroups = companyGroups.filter(group => group.name === data.name)
        sessionStorage.setItem("dupCheck", "false");
        if (companyGroups.length > 0) {
          // 重複した場合、dupCheckをtrueにする
          sessionStorage.setItem("dupCheck", "true");
        }
        // 重複しない場合、グループ保存処理実行
        if (sessionStorage.getItem("dupCheck") === "false") {
          isDisabled.current = true;
          data.deleteFlg = isDeleteGroup === "deleteTrue";
          if (isUpdate) {
            try {
              console.debug("GroupList: calling updateGroup with", data);
              await companiesQuery.updateGroup(currentUser?.tenantId!, data);
              console.debug("GroupList: updateGroup call completed for", data.id);
            } catch (e) {
              console.error("GroupList: updateGroup failed", e);
            }
            const prevGroup = (groups ?? []).find(g => g.id === data.id);
            const prevDeleteFlg = prevGroup?.deleteFlg ?? false;
            const newDeleteFlg = data.deleteFlg ?? false;
            if (prevGroup && prevDeleteFlg !== newDeleteFlg) {
              setActiveCount(prev => {
                const delta = newDeleteFlg ? -1 : 1;
                const next = (prev ?? 0) + delta;
                return next < 0 ? 0 : next;
              });
            }

            setGroups(prev => prev.map(g => g.id === data.id ? { ...g, ...data } : g));
            setUpGroupData({ ...data, updateAt: new Date() });
            setUpdateKey(prev => prev + 1);
            setIsLode(true);
          } else {
            await companiesQuery.addGroup(currentUser?.tenantId!, data);
            const newItem = { ...(data as Groups), createAt: new Date(), updateAt: new Date() } as Groups;

            const current = groups ?? [];
            const pageSize = selectNumber;
            let shouldInsert = true;
            try {
              if (!sortKey) {
                shouldInsert = current.length < pageSize;
              } else if (current.length === 0) {
                shouldInsert = true;
              } else if (current.length < pageSize) {
                shouldInsert = true;
              } else {
                const keyMap: Record<string, (g: Groups) => any> = {
                  name_kana: (g) => g.nameKana ?? '',
                  name: (g) => g.nameKana ?? '',
                  userCount: (g) => g.userCount ?? 0,
                  adminCount: (g) => g.adminCount ?? 0,
                  deleteFlg: (g) => (g.deleteFlg ? 1 : 0),
                };
                const accessor = keyMap[sortKey] ?? ((g: Groups) => g.nameKana ?? '');
                const newVal = accessor(newItem);
                const firstVal = accessor(current[0]);
                const lastVal = accessor(current[current.length - 1]);

                if (typeof newVal === 'string' && typeof firstVal === 'string' && typeof lastVal === 'string') {
                  if (sortOrder === 'asc') {
                    shouldInsert = newVal.localeCompare(firstVal, 'ja') >= 0 && newVal.localeCompare(lastVal, 'ja') <= 0;
                  } else {
                    shouldInsert = newVal.localeCompare(firstVal, 'ja') <= 0 && newVal.localeCompare(lastVal, 'ja') >= 0;
                  }
                } else {
                  if (sortOrder === 'asc') {
                    shouldInsert = newVal >= firstVal && newVal <= lastVal;
                  } else {
                    shouldInsert = newVal <= firstVal && newVal >= lastVal;
                  }
                }
              }
            } catch (e) {
              shouldInsert = true;
            }

            if (shouldInsert) {
              setGroups(prev => {
                const next = [newItem, ...prev];
                if (next.length > pageSize) next.pop();

                if (sortKey) {
                  const keyMap: Record<string, (g: Groups) => any> = {
                    name_kana: (g) => g.nameKana ?? '',
                    name: (g) => g.nameKana ?? '',
                    userCount: (g) => g.userCount ?? 0,
                    adminCount: (g) => g.adminCount ?? 0,
                    deleteFlg: (g) => (g.deleteFlg ? 1 : 0),
                  };
                  const accessor = keyMap[sortKey] ?? ((g: Groups) => g.nameKana ?? '');

                  const arr = next.map((g, i) => ({ item: g, idx: g.id === newItem.id ? 0 : i + 1 }));
                  arr.sort((a, b) => {
                    const va = accessor(a.item);
                    const vb = accessor(b.item);
                    if (typeof va === 'string' && typeof vb === 'string') {
                      const cmp = sortOrder === 'asc' ? va.localeCompare(vb, 'ja') : vb.localeCompare(va, 'ja');
                      return cmp !== 0 ? cmp : a.idx - b.idx;
                    }
                    const diff = (va as number) - (vb as number);
                    return diff !== 0 ? (sortOrder === 'asc' ? diff : -diff) : a.idx - b.idx;
                  });
                  const sorted = arr.map(x => x.item);
                  return sorted;
                }

                return next;
              });
            } else {
            }
            setTotalCount(prev => (prev ?? 0) + 1);
            if (!data.deleteFlg) setActiveCount(prev => (prev ?? 0) + 1);
            setUpGroupData(newItem);
            setTimeout(() => setUpdateKey(prev => prev + 1), 2000);
          }
          dispatch(alertOpen(AlertValue("グループを保存しました。", "success")));
          toggle();
          isDisabled.current = false;
        }
      } catch (err: any) {
        let errorMessage = err.code;
        if (errorMessage === "ERR_NETWORK") {
          dispatch(
            alertOpen(AlertValue(ConstMessage.ERR_CONNECT_TO_NETWORK, "danger"))
          );
        } else {
          console.error(err)
          dispatch(alertOpen(AlertValue(ConstMessage.ERR_SAVE, "danger")));
        }
        isDisabled.current = false;
      }
    }
  }

  // GridRowのカラム設定
  interface CustomGridRow extends GridRow {
    id: string;
    adminCount: number;
  }

  // 管理者設定 登録押下
  const adminSubmit = async (data: Groups) => {
    if (isDisabled.current) return;

    try {
      setIsUpdateLoading(true);
      isDisabled.current = true;
      // 管理者権限更新
      if (changeCheckedAdminFlgList?.length) {
        await userQuery.updateAdminFlg(currentUser!.tenantId!, changeCheckedAdminFlgList, true, data.id);
      }
      if (changeUncheckedAdminFlgList?.length) {
        await userQuery.updateAdminFlg(currentUser!.tenantId!, changeUncheckedAdminFlgList, false, data.id);
      }

      // 画面用リスト更新
      setAdminFlgList(
        selectableUserList
          .map((item) => {
            const indexNum = item.groups.findIndex(g => g.id === group?.id);
            if (changeCheckedAdminFlgList?.includes(item.id)) item.groups[indexNum].adminFlg = true;
            if (changeUncheckedAdminFlgList?.includes(item.id)) item.groups[indexNum].adminFlg = false;
            return item.groups[indexNum].adminFlg ? item : null;
          })
          .filter((item): item is UserData => item !== null)
      );

      const checkedCount = changeCheckedAdminFlgList?.length || 0;
      const uncheckedCount = changeUncheckedAdminFlgList?.length || 0;
      const finalAdminCount = data.adminCount - uncheckedCount + checkedCount; 

      setRowListAdmin((prevRowList) => {
        return prevRowList.map((row) => {
          if (row.id === data.id) {
            return {
              ...row,
              adminCount: finalAdminCount,
            };
          }
          return row;
        });
      });

      // 管理者数の最新カウント取得
      const afterAdminCount = await userQuery.getAdminCount(data.id, currentUser!.tenantId!);

      if (afterAdminCount !== data.adminCount) {
        const updateGroupsData: Partial<Groups> = {
          id: data.id,
          adminCount: afterAdminCount,
          updateAt: new Date(),
        };
        await companiesQuery.updateGroup(currentUser!.tenantId!, { ...(data as Groups), ...updateGroupsData });
        setUpGroupData({ ...(data as Groups), ...updateGroupsData });
        setUpdateKey(prev => prev + 1);
      }

      // 管理者の変更を管理者一覧UIに即座に反映
      try {
        const currentAdmins = adminFlgList ?? [];
        // 新規にチェックされたユーザーを追加
        const additions = changeCheckedAdminFlgList ?? [];
        const removals = changeUncheckedAdminFlgList ?? [];
        // selectableUserList から追加ユーザーの情報を取得
        const addedUsers = (selectableUserList ?? []).filter(u => additions.includes(u.id));
        const keptAdmins = currentAdmins.filter(u => !removals.includes(u.id));
        const newAdmins = [...keptAdmins, ...addedUsers];
        setAdminFlgList(newAdmins);
        setCheckedAdminFlgList(newAdmins.map(u => u.id));
        setChangeCheckedAdminFlgList([]);
        setChangeUncheckedAdminFlgList([]);
      } catch (err) {
        console.error(err);
      }

      await new Promise(resolve => setTimeout(resolve, 600));
      setIsUpdateAdmin(prev => !prev);

      dispatch(alertOpen(AlertValue(ConstMessage.SUCCESS_SAVE_ADMINFLG, "success")));
      adminSettingToggle();
    } catch (err: any) {
      console.error(err);
      const msg = err.code === "ERR_NETWORK" ? ConstMessage.ERR_CONNECT_TO_NETWORK : ConstMessage.ERR_SAVE;
      dispatch(alertOpen(AlertValue(msg, "danger")));
    } finally {
      isDisabled.current = false;
      setIsUpdateLoading(false);
    }
  };

  // ユーザー編集 登録
  const groupUserSubmit = async (data: Groups) => {
    if (isDisabled.current) return;
    if (group!.deleteFlg) return notEditableToggle();

    try {
      isDisabled.current = true;

      // ページ跨ぎの変更
      const checkedfilter = changeCheckedGroupUserList ?? [];
      const unCheckedfilter = changeUncheckedGroupUserList ?? [];

      // 現在の所属ユーザー数取得（件数のみ）
      const defaultUserCount = await userQuery.getGroupsUserCount(
        data.id,
        currentUser!.tenantId!
      );

      // 重複や矛盾を解消
      const addSet = new Set(checkedfilter);
      const delSet = new Set(unCheckedfilter);

      for (const id of addSet) {
        if (delSet.has(id)) {
          addSet.delete(id);
          delSet.delete(id);
        }
      }
      const finalAddCount = addSet.size;
      const finalDeleteCount = delSet.size;
      const finalTotal = defaultUserCount + finalAddCount - finalDeleteCount;
      
      if (finalTotal > 1000) {
        dispatch(alertOpen(AlertValue("グループに所属できる利用者は最大1000人です。", "danger")));
        return;
      }

      setIsUpdateLoading(true);

      // 追加処理
      if (finalAddCount > 0) {
        await Promise.all(
          Array.from(addSet).map((userId) =>
            userQuery.addAttendingGroups(currentUser!.tenantId!, userId, data.id)
          )
        );
      }

      // 削除処理
      if (finalDeleteCount > 0) {
        await Promise.all(
          Array.from(delSet).map((userId) =>
            userQuery.deleteAttendingGroups(currentUser!.tenantId!, userId, data.id)
          )
        );
      }

      // 最新カウント取得
      const newUserCount = await userQuery.getGroupsUserCount(data.id, currentUser!.tenantId!);
      const newAdminCount = await userQuery.getAdminCount(data.id, currentUser!.tenantId!);

      const updatedData: Partial<Groups> = { id: data.id, updateAt: new Date() };
      let needUpdate = false;
      if (newUserCount !== data.userCount) {
        updatedData.userCount = newUserCount;
        needUpdate = true;
      }
      if (newAdminCount !== data.adminCount) {
        updatedData.adminCount = newAdminCount;
        needUpdate = true;
      }

      if (needUpdate) {
        await companiesQuery.updateGroup(currentUser!.tenantId!, updatedData as Groups);
        setUpGroupData({ ...data, ...updatedData });
        setUpdateKey(prev => prev + 1);
      }

      // ローカルのユーザーリストを即時更新してモーダル再表示時に変更が反映されるようにする
      try {
        const added = Array.from(addSet);
        const removed = Array.from(delSet);
        if ((groupUserEditList ?? []).length > 0) {
          const updatedList = (groupUserEditList ?? []).map(user => {
            const newGroups = [...(user.groups ?? [])];
            if (added.includes(user.id)) {
              // グループエントリが存在しない場合は追加
              if (!newGroups.some(g => g.id === data.id)) {
                newGroups.push({ id: data.id, name: data.name, color: data.groupColor, adminFlg: false, disabled: false } as any);
              }
            }
            if (removed.includes(user.id)) {
              // グループエントリを削除
              for (let i = newGroups.length - 1; i >= 0; i--) {
                if (newGroups[i].id === data.id) newGroups.splice(i, 1);
              }
            }
            return { ...user, groups: newGroups };
          });
          setGroupUserEditList(updatedList);
        }

        // 変更リストをクリアして UI が永続化された状態を表示するようにする
        setChangeCheckedGroupUserList([]);
        setChangeUncheckedGroupUserList([]);

      } catch (err) {
        console.error(err);
      }

      dispatch(alertOpen(AlertValue(ConstMessage.SUCCESS_SAVE_GROUPSUSER, "success")));
      groupUserEditToggle();

    } catch (err: any) {
      console.error(err);
      dispatch(alertOpen(AlertValue(ConstMessage.ERR_SAVE, "danger")));
    } finally {
      isDisabled.current = false;
      setIsUpdateLoading(false);
    }
  };
  
  // グループ編集モーダル開閉
  const toggle = () => {
    setNowGroupPage(1)
    setIsGroupUserListLoading(true);
    setIsOpen(!isOpen);
  };

  // 管理者一覧モーダル開閉
  const adminListToggle = () => {
    setIsAdminListOpen(!isAdminListOpen);
  };

  // 管理者設定モーダル開閉
  const adminSettingToggle = async () => {
    setCheckedAdminFlgList([]);
    setChangeCheckedAdminFlgList([]);
    setChangeUncheckedAdminFlgList([]);
    setNowAdminUserPage(1);
    setIsAdminSettingLoading(true);
    setIsAdminSettingOpen(!isAdminSettingOpen);
  };

  // グループユーザ編集モーダル開閉
  const groupUserEditToggle = () => {
    setIsUserListLoading(true);
    setCheckedGroupUserList([]);
    setChangeCheckedGroupUserList([]);
    setChangeUncheckedGroupUserList([]);
    setSearchUserList([]);
    setSearchCondition([]);
    setNowUserPage(1)
    setIsGroupUserEditOpen(!isGroupUserEditOpen);
    setSearchUserListFlg(false);
  };

  // 編集不可モーダル開閉
  const notEditableToggle = () => {
    setIsNotEditableModalOpen(!isNotEditableModalOpen);
  }

  // グループ新規作成押下
  const onCreateGroup = (group: Groups, isUpdate: boolean) => {
    setIsUpdate(isUpdate);
    setGroup(group);
    if(isUpdate){
      const groupToAttendingGroup = attendingGroups.filter((item) => item.id === group.id);
      const groupUserIdList = groupToAttendingGroup.map((item) => item.userId);
      const groupUserList = userList.filter((user) => groupUserIdList.includes(user.id));
      setGroupUserList(groupUserList);
    } else {
      setGroupUserList([]);
    }
    toggle();
  }

  // 設定押下
  const onSelectAdminUser = (group: Groups, isUpdate: boolean) => {
    setGroup(undefined);
    setAdminRows([]);
    setIsAdminListLoading(true);
    setIsUpdate(isUpdate);
    setGroup(group);
    setIsAdminListOpen(true);
  };

  // 管理者設定　チェックボックス更新
  const adminFlgOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const userId = event.target.dataset.id!;
    const checked = event.target.checked;

    // 表示用リスト更新
    setCheckedAdminFlgList((prev) => {
      const newList = prev ? [...prev] : [];
      if (checked) {
        if (!newList.includes(userId)) newList.push(userId);
      } else {
        const index = newList.indexOf(userId);
        if (index > -1) newList.splice(index, 1);
      }
      return newList;
    });

    // 内部追加／削除リスト更新
    setChangeCheckedAdminFlgList((prev) => {
      const newList = prev ? [...prev] : [];
      if (checked) {
        if (!newList.includes(userId)) newList.push(userId);
      } else {
        const index = newList.indexOf(userId);
        if (index > -1) newList.splice(index, 1);
      }
      return newList;
    });

    setChangeUncheckedAdminFlgList((prev) => {
      const newList = prev ? [...prev] : [];
      if (!checked) {
        if (!newList.includes(userId)) newList.push(userId);
      } else {
        const index = newList.indexOf(userId);
        if (index > -1) newList.splice(index, 1);
      }
      return newList;
    });
  };

  // ユーザー編集　チェックボックス更新
  const groupUserOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const userId = event.target.dataset.id!;
    const checked = event.target.checked;

    // 表示用リスト更新
    setCheckedGroupUserList((prev) => {
      const newList = prev ? [...prev] : [];
      if (checked) {
        if (!newList.includes(userId)) newList.push(userId);
      } else {
        const index = newList.indexOf(userId);
        if (index > -1) newList.splice(index, 1);
      }
      return newList;
    });

    // 内部追加／削除リスト更新
    setChangeCheckedGroupUserList((prev) => {
      const newList = prev ? [...prev] : [];
      if (checked) {
        if (!newList.includes(userId)) newList.push(userId);
      } else {
        const index = newList.indexOf(userId);
        if (index > -1) newList.splice(index, 1);
      }
      return newList;
    });

    setChangeUncheckedGroupUserList((prev) => {
      const newList = prev ? [...prev] : [];
      if (!checked) {
        if (!newList.includes(userId)) newList.push(userId);
      } else {
        const index = newList.indexOf(userId);
        if (index > -1) newList.splice(index, 1);
      }
      return newList;
    });
  };

  const onGroupUserEdit = (group: Groups) => {
    setGroup(group);
    groupUserEditToggle();
  }

  return (
    <div className="h-full">
      {/* グループ編集モーダル */}
      {isOpen && (<GroupAddModal
        open={isOpen}
        toggle={toggle}
        closeOnClickOutside={true}
        children={undefined}
        group={group}
        isUpdate={isUpdate}
        groupUserList={groupUserList}
        cols={userCols}
        rows={userRows}
        onClickSubmit={onClickSubmit}
        setIsDeleteGroup = {setIsDeleteGroup}
        firstPageFlg={firstGroupPageFlg}
        setFirstPageFlg={setFirstGroupPageFlg}
        pagingFunc={pagingGroupFunc}
        totalCount={totalGroupCount}
        isLode={isGroupUserListLoading} 
      />)}
      {/* 管理者一覧モーダル */}
      {isAdminListOpen && (<GroupAdminListModal
        open={isAdminListOpen}
        toggle={adminListToggle}
        adminSettingToggle={adminSettingToggle}
        closeOnClickOutside={true}
        children={undefined}
        group={group}
        cols={adminCols}
        rows={adminRows}
        isLode={isAdminListLoading} 
      />)}
      {/* 管理者設定モーダル */}
      {isAdminSettingOpen && (<GroupAdminSettingModal
        open={isAdminSettingOpen}
        toggle={adminSettingToggle}
        closeOnClickOutside={true}
        children={undefined}
        group={group}
        cols={adminsettingCols}
        rows={adminsettingRows}
        onClickSubmit={adminSubmit}
        firstPageFlg={firstAdminUserPageFlg}
        setFirstPageFlg={setFirstAdminUserPageFlg}
        pagingFunc={pagingAdnminUserFunc}
        totalCount={totalAdminUserCount}
        isLode={isAdminSettingLoading}
        isUpdateLode={isUpdateLoading} 
      />)}
      {/* グループユーザ編集モーダル */}
      {isGroupUserEditOpen && (<GroupUserEditModal
        open={isGroupUserEditOpen}
        toggle={groupUserEditToggle}
        closeOnClickOutside={true}
        children={undefined}
        group={group}
        cols={groupUserEditCols}
        rows={groupUserEditRows}
        userList={groupUserEditList}
        setSearchUserList={setSearchUserList}
        setSearchUserListFlg={setSearchUserListFlg}
        filteredActiveUsers={filteredActiveUsers}
        groupList={groups}
        searchKey1List={searchKey1List}
        searchKey2List={searchKey2List}
        searchKey3List={searchKey3List}
        searchKeyList={searchKeyList}
        onClickSubmit={groupUserSubmit}
        companyData={company}
        firstPageFlg={firstUserPageFlg}
        setFirstPageFlg={setFirstUserPageFlg}
        setIsUpdateSearchKeys={setIsUpdateSearchKeys}
        onSearch={handleSearch}
        searchCondition={searchCondition}
        pagingFunc={pagingUserFunc}
        totalCount={totalUserCount}
        isLode={isUserListLoading}
        isUpdateLode={isUpdateLoading}
      />)}
      {/* 編集不可モーダル */}
      {isNotEditableModalOpen && (<NotEditableModal
        open={isNotEditableModalOpen}
        toggle={notEditableToggle}
        closeOnClickOutside={true}
        children={undefined}
      />)}
      <div className="sm:flex flex-wrap sm:items-center px-6 pt-6">
        <div className="flex min-w-[100%]">
          <div className="flex flex-auto items-end space-x-4">
            <h2 className="text-xl font-semibold text-gray-900">
              グループ一覧
            </h2>
            <h3>登録数: {`${totalCount}`}</h3>
            <h3>有効数: {`${activeCount}`}</h3>
          </div>
          <div>
            <Button
              size={"sm"}
              onClick={() =>  onCreateGroup(newGroup, false)}
            >
              グループ新規作成
            </Button>
          </div>
        </div>
        <div>
          <h3 className="ml-8 mt-2 text-red-500">
            {ConstMessage.MSG_OPERATION_NOT_POSSIBLE_NO_GROUPADMIN}
          </h3>
        </div>
      </div>
      {isLode === true ? <Spiner/> : (
        <div className={"px-6"}>
          <TableList
            header
            gridCol={columns}
            gridRow={rowList}
            limit={selectNumber}
            gridRowLength={totalCount}
            firstPageFlg={firstPageFlg}
            setFirstPageFlg={setFirstPageFlg}
            pagingFunc={pagingFunc}
            onCustomSort={(key, order) => {
              setSortKey(key);
              setSortOrder(order);
            }}
            currentPage={nowPage ?? 1}
            setCurrentPage={setNowPage}
          />
        </div>
        )
      }
    </div>
  );
};
